import { ENV } from "../utils";

// Horas-hombre trabajadas + dotación por sitio/mes, propio del módulo
// Accidentes — denominador de los índices de Frecuencia/Gravedad/Incidencia
// en AccidentsDashboard (ver server/models/accidentHoursWorked.js).
export class AccidentHoursWorked {
  baseApi = ENV.BASE_API;

  async getAccidentHoursWorked(accessToken, params = {}) {
    const qs = new URLSearchParams();
    if (params.site) qs.set("site", params.site);
    const res = await fetch(`${this.baseApi}/accident-hours-worked?${qs}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async upsertAccidentHoursWorked(accessToken, body) {
    const res = await fetch(`${this.baseApi}/accident-hours-worked`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async deleteAccidentHoursWorked(accessToken, id) {
    const res = await fetch(`${this.baseApi}/accident-hours-worked/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
